module.exports = __webpack_public_path__ + "img/loadVideo.cee34182.gif";